<template>
  <div class="basic-table">
    <el-table
      v-if="type==='manage'"
      :data="TableData"
      border
      style="width: 100%"
      @selection-change="selectGoods"
    >
      <el-table-column
        type="selection"
        width="55"
        fixed="left"
      >
      </el-table-column>
      <el-table-column
        label="序号"
        width="60"
        type="index"
      >
      </el-table-column>
      <el-table-column
        prop="ruigu_code"
        label="锐锢商城编码"
        width="110"
      >
      </el-table-column>
      <el-table-column
        prop="self_code"
        label="商品编码"
        width="60"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        width="330"
      >
      </el-table-column>
      <el-table-column
        prop="spec"
        label="规格型号"
        width="210"
      >
      </el-table-column>
      <el-table-column
        prop="c_name"
        label="分类"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="b_name"
        label="品牌"
      >
      </el-table-column>
      <el-table-column
        prop="is_enable"
        label="状态"
      >
      </el-table-column>
  
      <el-table-column
        prop="is_sale"
        label="是否在售"
      >
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="80"
      >
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            :disabled="scope.row.is_enable==='启用'"
            @click="init(scope.row.id)"
          >启用</el-button>
          <el-button
            type="text"
            :disabled="scope.row.is_enable==='停用'"
            @click="uninit(scope.row.id)"
          >停用</el-button> -->
          <el-button
            type="text"
            style="color:#236bdc;"
            @click="editGoods(scope.row.id)"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      @selection-change="handleSelectionChange"
      v-if="type==='classify'"
      :data="TableData"
      border
      :row-class-name="tableRowClassName"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        :selectable="checkboxInit"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="序号"
        width="60"
        type="index"
      >
      </el-table-column>
      <el-table-column
        prop="bianma"
        label="已选品"
        width="60"
      >
      <template slot-scope="scope">
        <i class="el-icon-success" v-show="scope.row.is_select===1"></i>
      </template>
      </el-table-column>
      <el-table-column
        prop="bianma"
        label="锐锢商城编码"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="product_name"
        label="商品名称"
        width="360"
      >
      </el-table-column>
      <el-table-column
        prop="model"
        label="规格型号"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="c_name"
        label="分类"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="品牌"
      >
      </el-table-column>
      <el-table-column
        prop="is_sale"
        label="是否在售"
      >
      </el-table-column>

    </el-table>
  </div>
</template>
<script>
// import { updateGoods } from '@/models/goodsModel'
export default {
  props: ['TableData', 'type'],
  data () {
    return {
      formData: ''
    }
  },

  methods: {
    editGoods (id) {
      this.$emit('editGoods', id)
    },
    selectGoods (val) {
      this.$emit('getSelectGoods', val)
    },
    // async init (id) {
    //   let params = {
    //     id: id,
    //     is_enable: 1
    //   }
    //   await updateGoods(params)
    //   this.$emit('update')
    // },
    // async uninit (id) {
    //   let params = {
    //     id: id,
    //     is_enable: 0
    //   }
    //   await updateGoods(params)
    //   this.$emit('update')
    // },
    handleSelectionChange (val) {
      let data = ''
      for (let i of val) {
        if (data) {
          data = data + ',' + i.bianma
        } else {
          data = i.bianma
        }
      }
      this.formData = { ruigu_code: data }
    },
    checkboxInit (row, index) {
      return row.checkBoxType
    },
    tableRowClassName ({row, index}) {
      return row.className
    }
  }
}
</script>
<style lang="scss">
.basic-table {
  .el-table {
    margin-top: 10px;
    .warning-row{
      background: #f5f7fa;
    }
  }
  // .el-table .cell,
  // .el-table th div {
  //   padding: 6px 0;
  // }
  .el-table td,
  .el-table th {
    text-align: center;
  }
  .el-icon-success {
    color:green;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/basic-table.vue